import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import EN from "@/constants/en";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const navLinks = [
        { text: EN.NAV_DEMOS, href: "/#demos" },
        { text: EN.NAV_ABOUT, href: "/#about" },
        { text: EN.NAV_EXPERIENCE, href: "/#experience" },
        { text: EN.NAV_SKILLS, href: "/#skills" },
        { text: EN.NAV_PROJECTS, href: "/projects" },
        { text: EN.NAV_VENTURES, href: "/ventures" },
        { text: EN.NAV_EDUCATION, href: "/#education" },
        { text: EN.NAV_TECHNOLOGIES, href: "/#technologies" },
    ];

    return (
        <header className={`fixed top-0 w-full z-50 transition-all duration-300 ${scrolled ? "bg-white shadow-md py-2" : "bg-transparent py-4"}`}>
            <div className="container-custom flex justify-between items-center">
                <Link to="/#hero" className="text-xl font-bold text-primary">
                    {EN.SITE_TITLE}
                </Link>

                {/* Desktop Navigation */}
                <nav className="hidden md:flex items-center space-x-2">
                    {navLinks.map((link, index) => (
                        <Link key={index} to={link.href} className="hover:text-accent transition-colors font-medium flex items-center min-h-[48px] min-w-[48px] px-3 py-2 justify-center">
                            {link.text}
                        </Link>
                    ))}
                    <Button asChild>
                        <Link to="/#contact" className="bg-accent hover:bg-accent/90">
                            {EN.NAV_CONTACT}
                        </Link>
                    </Button>
                </nav>

                {/* Mobile Menu Button */}
                <Button 
                    variant="ghost" 
                    size="icon" 
                    className="md:hidden" 
                    onClick={toggleMenu}
                    aria-label={isMenuOpen ? EN.MENU_TOGGLE_CLOSE_ARIA_LABEL : EN.MENU_TOGGLE_OPEN_ARIA_LABEL}
                >
                    {isMenuOpen ? <X /> : <Menu />}
                </Button>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="md:hidden absolute top-full left-0 w-full bg-white shadow-lg animate-fade-in">
                    <div className="container py-4 flex flex-col space-y-2">
                        {navLinks.map((link, index) => (
                            <Link key={index} to={link.href} className="min-h-[48px] hover:text-accent transition-colors flex items-center px-4 py-3" onClick={toggleMenu}>
                                {link.text}
                            </Link>
                        ))}
                        <Button asChild onClick={toggleMenu}>
                            <Link to="/#contact">{EN.NAV_CONTACT}</Link>
                        </Button>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
